module.exports = __webpack_public_path__ + "static/media/blog_img4.131affd7.jpg";